import { api } from '@/services'

export async function addCouponRequest(id: string, coupon: string) {
    try {
        const { data } = await api.post('Cart/AddCupom', null, {
            params: {
                CheckoutId: id,
                IdCupom: coupon
            }
        })
        console.log(data)

        return { data }
    } catch (error) {
        console.error(error)
    }
}
